import React from 'react';
import styled from 'styled-components';

// The Sterling page closes with its own call to action and document links, so
// this is deliberately just the legal line underneath it rather than a second
// navigation block.
const Wrap = styled.footer`
  background: #F8F4EE;
  border-top: 1px solid rgba(28, 28, 28, 0.10);
  padding: 32px 0 40px;
`;

const Inner = styled.div`
  width: 90%;
  max-width: 1080px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-body);
  font-size: 0.86rem;
  color: #6B6259;
`;

const Links = styled.div`
  display: flex;
  gap: 18px;

  a {
    color: #6B6259;
    text-decoration: none;
    &:hover { color: #C75D3D; }
  }
`;

export default function Footer() {
  return (
    <Wrap>
      <Inner>
        <span>© {new Date().getFullYear()} STERLING DINE LLC. Sterling and the Sterling Standard are trademarks of STERLING DINE LLC.</span>
        <Links>
          <a href="/legal/sterling-privacy.html">Privacy Policy</a>
          <a href="/legal/sterling-terms.html">Terms of Use</a>
          <a href="/support/sterling.html">Support</a>
          <a href="mailto:support@sterlingdine.com">Contact</a>
        </Links>
      </Inner>
    </Wrap>
  );
}
